import { render, staticRenderFns } from "./BulkMovingCreate.vue?vue&type=template&id=0ad77e5b&scoped=true&"
import script from "./BulkMovingCreate.vue?vue&type=script&lang=js&"
export * from "./BulkMovingCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkMovingCreate.vue?vue&type=style&index=0&id=0ad77e5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad77e5b",
  null
  
)

export default component.exports